import React from "react";
import leftPng from "../../../../content/images/left.png";

const Edit = () => {
  return (
    <div id="editSide" className="d-none">
      <div className="detail-title">Discipline in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Discipline
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit_discipline" className="button ok">
            Opslaan
          </a>
        </div>
        <div className="float-right mt-0 w-20">
          <a id="return-detail" className="button back">
            Annuleren
          </a>
        </div>
      </div>

      <div className="row clearfix">
        {/* <div className="col-lg-6 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam discipline*</div>
            <div className="box-title-2-active">
              <input id="e-algemeenNaam" />
            </div>
          </div>
        </div> */}
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="e-discipline_active" type="checkbox" />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
